import styled from 'styled-components'

export const FacilityVisitorContainer = styled.div`
  width: 100%;
  padding: 50px;
`

export const FacilityVisitorItemContainer = styled.div`
  display: flex;
  align-items: center;
`
export const FacilityVisitorTitle = styled.h1`
  margin: 0;
`

export const FacilityVisitorImageContainer = styled.div`
  position: absolute;
  display: flex;
  right: 100px;
`

export const FacilityVisitorImage = styled.img`
  width: 350px;
`

export const FacilityVisitorFavoriteContainer = styled.div`
  display: flex;
  cursor: pointer;
  margin-top: 15px;
  margin-right: 30px;
  justify-content: center;
`

export const FacilityVisitorFavoriteTitle = styled.p`
  margin: 0;
  margin-right: 10px;
`
export const FacilityVisitorDescription = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  color: ${({ theme }) => theme.colors.fontSecondary};
`

export const FacilityVisitorAddress = styled.div`
  margin-top: 15px;
  margin-bottom: 25px;
  color: ${({ theme }) => theme.colors.fontSecondary};
`
export const FacilityVisitorLocationIconContainer = styled.div`
  font-size: 1.5em;
  color: ${({ theme }) => theme.colors.primary};
  margin-left: 0.35em;
`

export const FacilityVisitorCourtContainer = styled.div`
  margin-top: 28px;
`

export const FacilityVisitorCalendarContainer = styled.div`
  border-top: 1px solid #e0e0e0;
  margin-top: 51px;
  width: 100%;
  display: flex;
`

export const FacilityVisitorCalendarSubContainer = styled.div`
  width: 50%;
  border-right: 1px solid #e0e0e0;
`
export const FacilityVisitorRightContainer = styled.div`
  width: 50%;
`
export const FacilityVisitorToolbarContainer = styled.div`
  margin-top: 32px;
  padding-bottom: 17px;
  border-bottom: 1px solid #e0e0e0;
`
